import React from 'react';
import ReactDOM from 'react-dom';
import Keycloak from 'keycloak-js';

import request from 'store/utils/request';
import Routes from 'scenes/Routes';
import store, { history } from 'store';
import { loginUserUsingKeycloak } from 'store/services/session/actions';
import { refreshToken } from '../store/services/session/actions';

const THIRTY_SECS_INTERVAL = 30000;
// // The initial login returns a token with a lifespan of 5 minutes.
// // That is set in keycloak dashboard
const FIVE_MINUTES_TOKEN_VALIDITY = 300;

let interval;

const isKeycloakEnabled = async () =>
  process.env.KEYCLOAK_SERVER_URL &&
  process.env.KEYCLOAK_REALM_NAME &&
  process.env.KEYCLOAK_CLIENT_ID
    ? Promise.resolve()
    : Promise.reject();

(async () => {
  try {
    await Promise.all([isKeycloakEnabled(), request.get('/auth/check')]);

    const keycloak = Keycloak({
      url: process.env.KEYCLOAK_SERVER_URL,
      realm: process.env.KEYCLOAK_REALM_NAME,
      clientId: process.env.KEYCLOAK_CLIENT_ID,
    });

    keycloak
      .init({
        onLoad: 'check-sso',
        checkLoginIframe: false,
      })
      .then(async authenticated => {
        if (authenticated) {
          try {
            await store.dispatch(loginUserUsingKeycloak(keycloak));
          } catch (err) {
            history.push('/verify-account');
          }

          interval = setInterval(() => {
            const expireSec = Math.round(
              (keycloak.tokenParsed.exp * 1000 - new Date().getTime()) / 1000,
            );

            console.log(`${expireSec} seconds remaining`);

            if (expireSec < 30) {
              keycloak
                .updateToken(FIVE_MINUTES_TOKEN_VALIDITY)
                .then(refreshed => {
                  if (refreshed) {
                    console.log('Token was successfully refreshed');
                    store.dispatch(refreshToken(keycloak.token));
                  } else {
                    console.log('Token is still valid');
                  }
                })
                .error(() => {
                  clearInterval(interval);
                  keycloak.login();
                });
            }
          }, THIRTY_SECS_INTERVAL);
        }

        ReactDOM.render(
          <Routes authenticated={authenticated} keycloak={keycloak} />,
          document.getElementById('app-root'),
        );
      })
      .catch(err => {
        console.log('sth went wrong while asking to init keycloak', err);
      });
  } catch {
    ReactDOM.render(
      <Routes authenticated={undefined} keycloak={undefined} />,
      document.getElementById('app-root'),
    );
  }
})();
